<div class="modal-wrapper" *ngIf="showForm" [ngClass]="{'loaded': loaded && loaded['loaded']}">
  <div class="wrapper scroll">
    <div class="under-wrapper" [ngClass]="{'loaded': loaded && loaded['loaded']}" sdClickOutside (clickOutside)="closeModal($event)" #parent
         [parentRef]="parent">
      <div class="navigation-bar">
        <span class="arrow-back ai ai-back" (click)="closeModal($event)"></span>
        <span class="heading5">{{ 'productVariants.availbility' |translate }}</span>
        <div class="img-wrapper cancel" (click)="closeModal($event)">
          <i class="ai ai-cancel"></i>
        </div>
      </div>
      <div class="separator-gray full-height separator-one-half"></div>
      <div class="img-wrapper cancel no-navigation-bar" (click)="closeModal($event)">
        <i class="ai ai-cancel"></i>
      </div>
      <div class="register-content">
        <div class="register-part" *ngIf="!successMsg">
          <div class="main-title">
            <p class="title">{{ 'login.forgotPassword' |translate }}</p>
            <p class="description">{{ 'login.resetPasswordReq' |translate }}</p>
          </div>
          <div class="register-form">
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
              <div class="show-email separator-one-half">
                <input appInputClick class="input" type="email" [placeholder]="emailPlaceholder" [formControlName]="ControlNames.EMAIL"
                       [name]="ControlNames.EMAIL" [id]="ControlNames.EMAIL" #showEmailInput>
                <label (click)="showEmailInput.focus()" class="form-label" [for]="ControlNames.EMAIL"
                       [ngClass]="{'is-Empty':showEmailInput.value==''}">{{emailPlaceholder}}</label>
                <sd-errors [control]="formGroup.controls[ControlNames.EMAIL]"></sd-errors>
              </div>
              <div class="error-bar" *ngIf="error">
                <app-alert-bar [errorText]="error?.type" [alertStatus]="'Error'" (publicCloseBar)="clearError()"></app-alert-bar>
              </div>
              <div class="button-wrapper separator2">
                <button class="button secondary-button" #registerButton>
                  <span [ngClass]="{'loader':!isLoading}"></span>{{isLoading?'': ('login.resetPassword' | translate)}}
                </button>
              </div>
            </form>
            <!--<p class="text-separator">lub</p>-->
            <!--<div class="button-wrapper">-->
            <!--<div class="button secondary-button" (click)="recoveryPasswordViaSms()">-->
            <!--Przypomnij hasło SMS-em-->
            <!--</div>-->
            <!--</div>-->
            <a class="success-link" [routerLink]="'/' + urlTranslateService.urlMapping.customer.login">{{ 'login.backToLoginPage' |translate }}</a>
          </div>
          <div class="separator-gray no-margin"></div>
          <p class="title">{{ 'login.haventAccount?' |translate }}</p>
          <div class="button-wrapper create-account-button">
            <div class="button secondary-button" (click)="goToCreateAccountPage()">{{ 'login.createAccount' |translate }}</div>
          </div>
        </div>
        <div class="success-part" *ngIf="successMsg">
          <p>{{ 'messageSend' |translate }}</p>
          <p>Na adres <span>{{savedEmail}}</span> <span [innerHtml]="successMsg"></span></p>
          <div class="button-wrapper">
            <div class="button tertiary-button" (click)="goToLoginPage()">{{ 'login.backToLoginPage' |translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
